import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-pricing',
  templateUrl: './homethree-pricing.component.html',
  styleUrls: ['./homethree-pricing.component.scss']
})
export class HomethreePricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
